import { render, staticRenderFns } from "./memberDate.vue?vue&type=template&id=4072feed&scoped=true"
import script from "./memberDate.vue?vue&type=script&lang=js"
export * from "./memberDate.vue?vue&type=script&lang=js"
import style0 from "./memberDate.vue?vue&type=style&index=0&id=4072feed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4072feed",
  null
  
)

export default component.exports